import { Box, Center } from '@chakra-ui/react';
import { Skeleton } from '@main/complykit/components/skeleton';
import { Text } from '@main/complykit/components/text';

/* Five tabs of the sidebar's own shape: a square control and its label
 * underneath, each taking the box of the real thing it stands for. */
export const TabsSkeleton = () => {
  return new Array(5).fill(0).map((_, index) => (
    <Center key={index} flexDirection="column" gap={1.5}>
      <Box w={8}>
        <Skeleton.Block size="md" />
      </Box>
      <Skeleton isLoading>
        <Text size="xs">Tab</Text>
      </Skeleton>
    </Center>
  ));
};
